/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelInterfaceCodes.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/interface-codes";

export class AutogenModelInterfaceCodes<RowType extends ModelRow> extends Endpoint<RowType, RowInterfaceCodesFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowInterfaceCodes extends ModelRow<RowInterfaceCodesFields> {
	constructor(values?: Partial<RowInterfaceCodesFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowInterfaceCodesFields {
	code_type: string;
	company_id: string;
	description: string;
	display_value: string;
	id: string;
}

